<template>
  <div v-show="canSee" ref="boxShow" style="z-index: 999">
    <div class="w1200 newsBox">
      <div ref="w1200" class="w1200" style="overflow: hidden;background-color: #F9F9F9">
        <div v-if="!isRead" class="tips">
          <svg-icon icon-class="dingwei" />
          <a href="/home" class="btnSty">首页</a>
          <span v-if="currentData.CLASS_NAME">/</span>
          <a href="javascript:;" class="btnSty" @click="goclass">{{ currentData.CLASS_NAME }}</a>
          <span v-if="currentData.SHOW_TITLE">/</span>
          <span style="margin-left: 5px;">{{ currentData.SHOW_TITLE }}</span>
        </div>
        <div v-show="!isRead" class="top_msg_show phoneImgBox">
          <span v-if="currentData.SHOW_SURNAME" class="top_msg_show_name" style="color: #7E6B5A">[</span><span v-if="currentData.SHOW_SURNAME" style="color: #7E6B5A" class="top_msg_show_name">{{ currentData.SHOW_SURNAME }}</span><span v-if="currentData.SHOW_SURNAME" style="color: #7E6B5A" class="top_msg_show_name">]</span>
          <span class="top_msg_show_name top_msg_show_name_title">{{ currentData.SHOW_TITLE }}</span>
          <span v-if="currentData.CLASS_NAME" class="class_name class_name_1">/{{ currentData.CLASS_NAME }}</span>
          <span v-if="currentData.SHOW_REGION" class="class_name"><svg-icon icon-class="dingwei" /> {{ currentData.SHOW_REGION }}</span>
          <span v-if="currentData.YEAR_NAME" class="class_name"><svg-icon icon-class="rili" /> {{ currentData.YEAR_NAME }}</span>
          <img v-if="currentData.SHOW_THUMB_URL" :src="currentData.SHOW_THUMB_URL" alt="" class="phoneImg">
          <img v-if="!currentData.SHOW_THUMB_URL" :src="fenmian" alt="" class="phoneImg">
          <div class="top_msg_show_user">
            <img v-if="currentData.HEADIMGURL" :src="currentData.HEADIMGURL" alt="">
            <img v-else :src="peng1" alt="">
            <span>{{ currentData.NICKNAME }}</span>
          </div>
        </div>
        <div v-show="isRead" class="top_msg_read">
          <p>{{ currentData.SHOW_TITLE }}</p>
          <div class="top_msg_read_user">
            <span>{{ currentData.CREATE_DATE }}</span>
            <img :src="currentData.HEADIMGURL" alt="">
            <span>{{ currentData.USER_REALNAME }}</span>
          </div>
        </div>
        <div class="topShow">
          <div class="top_left">
            <div class="left_phone leftImg">
              <div v-if="currentType==1" class="coverImg">
                <img :src="currentData.SHOW_THUMB_URL" alt="">
              </div>
              <div v-if="currentType==2" class="coverImg">
                <img :src="puwendefault" alt="">
              </div>
              <div v-if="currentType==3" class="coverImg">
                <img :src="puxidefault" alt="">
              </div>
              <div v-if="currentType==4" class="coverImg">
                <img :src="puxidefault" alt="">
              </div>
              <div class="tipname" />
              <div class="tipname_text">
                {{ currentData.PRIVACY_RULE }}
              </div>
            </div>
          </div>
          <div v-if="currentType==1" ref="top_right" class="top_right">
            <div ref="showli" class="showli">
              <div>
                <span class="showli_div_span1">题名</span>
                <span v-show="!isRead" class="showli_div_span2 showli_div_span1_line">：{{ currentData.BOOK_NAME|changenull }}</span>
                <span v-show="isRead" class="showli_div_span2 showli_div_span1_line" style="width: 400px;">：{{ currentData.BOOK_NAME|changenull }}</span>
              </div>
              <!--<div class="showli_div">-->
              <!--<span class="showli_div_span1">总题名</span>-->
              <!--<span class="showli_div_span2">：{{ currentData.BOOK_NAME }}</span>-->
              <!--</div>-->
              <div class="showli_div">
                <span class="showli_div_span1">更新时间</span>
                <span class="showli_div_span2">：{{ currentData.CREATE_DATE|changenull }}</span>
              </div>
              <div class="showli_div">
                <span class="showli_div_span1">堂号</span>
                <span class="showli_div_span2">：{{ currentData.BOOK_HALL_CODE|changenull }}</span>
              </div>
              <div class="showli_div phoneNO">
                <span class="showli_div_span1">查阅权限</span><span>：</span>
                <span class="showli_div_span2"><span class="showli_div_span2_class">{{ currentData.PRIVACY_RULE }}</span></span>
              </div>
              <div class="showli_div">
                <span class="showli_div_span1">编者</span>
                <span class="showli_div_span2">：{{ currentData.BOOK_AUTHOR|changenull }}</span>
              </div>
              <div class="showli_div">
                <span class="showli_div_span1">家谱类型</span><span>：</span>
                <span class="showli_div_span2"><span class="showli_div_span2_class">{{ currentData.BOOK_TYPE }}</span></span>
              </div>
              <div>
                <span class="showli_div_span1">编撰时间</span>
                <span v-show="!isRead" class="showli_div_span2 showli_div_span1_line">：{{ currentData.BOOK_TIME|changenull }}</span>
                <span v-show="isRead" class="showli_div_span2 showli_div_span1_line" style="width: 400px;">：{{ currentData.BOOK_TIME|changenull }}</span>
              </div>
              <div class="showli_div">
                <span class="showli_div_span1">页面数量</span>
                <span class="showli_div_span2">：{{ currentData.EDITION_PAGE_ALL_SIZE|changenull }}</span>
              </div>
            </div>
          </div>
          <div v-if="currentType==2" ref="top_right" class="top_right">
            <div ref="showli" class="showli">
              <div>
                <span class="showli_div_span1">谱文名称</span>
                <span v-show="!isRead" class="showli_div_span2 showli_div_span1_line">：{{ currentData.ARTICLE_NAME|changenull }}</span>
                <span v-show="isRead" class="showli_div_span2 showli_div_span1_line" style="width: 400px;">：{{ currentData.ARTICLE_NAME|changenull }}</span>
              </div>
              <div class="showli_div">
                <span class="showli_div_span1">谱文类型</span>
                <span class="showli_div_span2">：{{ currentData.ARTICLE_TYPE }}谱文</span>
              </div>
              <div class="showli_div">
                <span class="showli_div_span1">更新时间</span>
                <span class="showli_div_span2">：{{ currentData.CREATE_DATE|changenull }}</span>
              </div>
              <div class="showli_div">
                <span class="showli_div_span1">页面数量</span>
                <span class="showli_div_span2">：{{ currentData.ARTICLE_IMG_SIZE|changenull }}</span>
              </div>
              <div class="showli_div phoneNO">
                <span class="showli_div_span1">查阅权限</span><span>：</span>
                <span class="showli_div_span2"><span class="showli_div_span2_class">{{ currentData.PRIVACY_RULE }}</span></span>
              </div>
              <div class="showli_div">
                <span class="showli_div_span1">总字数</span>
                <span class="showli_div_span2">：{{ currentData.ARTICLE_SIZE|changenull }}字</span>
              </div>
            </div>
          </div>
          <div v-if="currentType==3" ref="top_right" class="top_right">
            <div ref="showli" class="showli">
              <div>
                <span class="showli_div_span1">谱系名称</span>
                <span v-show="!isRead" class="showli_div_span2 showli_div_span1_line">：{{ currentData.TREE_NAME|changenull }}</span>
                <span v-show="isRead" class="showli_div_span2 showli_div_span1_line" style="width: 400px;">：{{ currentData.TREE_NAME|changenull }}</span>
              </div>
              <div class="showli_div">
                <span class="showli_div_span1">主要姓氏</span>
                <span class="showli_div_span2">：{{ currentData.SHOW_SURNAME|changenull }}</span>
              </div>
              <div class="showli_div">
                <span class="showli_div_span1">更新时间</span>
                <span class="showli_div_span2">：{{ currentData.CREATE_DATE|changenull }}</span>
              </div>
              <div class="showli_div showli_div_node">
                <span class="showli_div_span1">重要人物</span>
                <span>：</span>
                <span class="showli_div_span2 showli_div_node">
                  <span v-for="(item,index) in currentData.FIRST_NODE_NAME" :key="index" class="nodeli">
                    {{ item }}
                  </span>
                </span>
              </div>
              <div class="showli_div phoneNO">
                <span class="showli_div_span1">查阅权限</span><span>：</span>
                <span class="showli_div_span2"><span class="showli_div_span2_class">{{ currentData.PRIVACY_RULE }}</span></span>
              </div>
              <div class="showli_div">
                <span class="showli_div_span1">人物记录</span>
                <span class="showli_div_span2">：{{ currentData.SUMS|changenull }}人</span>
              </div>
            </div>
          </div>
          <div v-if="currentType==4" ref="top_right" class="top_right">
            <div ref="showli" class="showli">
              <div>
                <span class="showli_div_span1">人物姓名</span>
                <span v-show="!isRead" class="showli_div_span2 showli_div_span1_line">：{{ currentData.NODE_NAME|changenull }}</span>
                <span v-show="isRead" class="showli_div_span2 showli_div_span1_line" style="width: 400px;">：{{ currentData.NODE_NAME|changenull }}</span>
              </div>
              <div class="showli_div">
                <span class="showli_div_span1">性别</span>
                <span class="showli_div_span2">：{{ currentData.NODE_SEX|changenull }}</span>
              </div>
              <div class="showli_div">
                <span class="showli_div_span1">更新时间</span>
                <span class="showli_div_span2">：{{ currentData.UPDATE_DATE|changenull }}</span>
              </div>
              <div class="showli_div">
                <span class="showli_div_span1">是否健在</span>
                <span class="showli_div_span2">：{{ currentData.NODE_LIFE_FLAG|changenull }}</span>
              </div>
              <div class="showli_div phoneNO">
                <span class="showli_div_span1">查阅权限</span><span>：</span>
                <span class="showli_div_span2"><span class="showli_div_span2_class">{{ currentData.PRIVACY_RULE }}</span></span>
              </div>
              <div>
                <span class="showli_div_span1">父母</span>
                <span class="showli_div_span2 showli_div_span1_line">：{{ currentData.RELATION_MAP|changenull }}</span>
              </div>
              <div>
                <span class="showli_div_span1">来源谱系</span>
                <span class="showli_div_span2 showli_div_span1_line">：{{ currentData.TREE_NAME|changenull }}
                  <a :href="'/sourceView?sourceId='+currentData.TREE_ID+'&type=3'" style="color: #E3003A">查看></a>
                </span>
              </div>
            </div>
          </div>
          <img ref="imgCode" :src="srcUrl" alt="" class="imgCode">
          <div ref="readBox" class="readBox">
            <a class="btn_read" href="javascript:;" @click="goread">
              <span><svg-icon icon-class="chakan" /></span>
              <span>在线查阅</span>
            </a>
            <a class="btn_read btn_read_code" href="javascript:;" @click="getImg">
              <span><svg-icon icon-class="codeicon" /></span>
              <span>手机查阅</span>
            </a>
            <div v-if="!isRead" class="bdsharebuttonbox moreShare2" style="margin-top: 5px;display: inline-block;height: 30px;line-height: 30px;margin-left: 137px">
              <a href="javascript:;" class="bds_more el-icon-share" data-cmd="more">
                <span style="font-size: 14px;margin-left: 5px">转发分享</span>
              </a>
            </div>
            <div v-if="isRead" class="bdsharebuttonbox moreShare2" style="margin-top: 5px;display: inline-block;height: 30px;line-height: 30px;margin-left: 10px">
              <a href="#" class="bds_more el-icon-share" data-cmd="more">
                <span style="font-size: 14px;margin-left: 5px">转发分享</span>
              </a>
            </div>
            <span v-show="isCollected" class="collect_span" style="display: inline-block;color: red;vertical-align:top;width: 20px;margin-top: 5px;height: 30px;line-height: 30px;cursor: pointer" @click="handelColect">
              <svg-icon icon-class="shoucang_true" style="font-size: 18px;margin-right: 5px" />
            </span>
            <span v-show="!isCollected" class="collect_span" style="display: inline-block;color: #7E6B5A;vertical-align:top;width: 20px;margin-top: 5px;height: 30px;line-height: 30px;cursor: pointer" @click="handelColect">
              <svg-icon icon-class="shoucang_false" style="font-size: 18px;" />
            </span>
            <span style="color: #7E6B5A;font-size: 14px;margin-left: 5px;cursor: pointer" @click="handelColect">立即收藏</span>
          </div>
        </div>
        <div class="showShare" @click="showpuyuecode">
          <span>进入小程序查阅</span>
        </div>
        <div class="leftBox">
          <div ref="box">
            <BookContent v-if="currentType==1" :list-data="listData" :current-data="currentData" />
            <articleContent v-if="currentType==2" :list-data="listData" :current-data="currentData" />
            <treeContent v-if="currentType==3" :list-data="listData" :current-data="currentData" />
            <nodeContent v-if="currentType==4" :list-data="listData" :current-data="currentData" />
            <!--<bookPageContent v-if="currentType==5" :list-data="listData" :current-data="currentData" />-->
            <!--<pictureContent v-if="currentType==6" :list-data="listData" :current-data="currentData" />-->
            <!--分享-->
            <div ref="share" class="share">
              <span>分享到:</span>
              <span class="icon" @click="weibo"><svg-icon icon-class="wb" /></span>
              <span class="icon" @click="qq"><svg-icon icon-class="qq" /></span>
              <span class="icon wxImg"><svg-icon icon-class="wx" />
                <div id="qrcode3" ref="qrcode3" />
              </span>
              <!--<span></span>-->
              <div class="bdsharebuttonbox moreShare">
                <a href="#" class="bds_more el-icon-more" data-cmd="more" />
              </div>
              <span class="btn" @click="shareImg">生成分享图片</span>
              <div class="rightbox">
                <span v-show="isCollected" style="display: inline-block;color: red;vertical-align:top;width: 20px;margin-top: 10px;height: 30px;line-height: 30px;cursor: pointer" class="el-icon-star-on" @click="handelColect" />
                <span v-show="!isCollected" style="display: inline-block;color: #CCCCCC;vertical-align:top;width: 20px;margin-top: 10px;height: 30px;line-height: 30px;cursor: pointer" class="el-icon-star-on" @click="handelColect" />
                <!--<span style="vertical-align:top;width: 70px;margin-top: 10px;height: 30px;line-height: 30px;display: inline-block;overflow: hidden;margin-left: 0;">{{ collectionSize }}</span>-->
                <!--<span @click="gopinlun"><svg-icon icon-class="pinlun" /></span>-->
                <!--<span class="num">111</span>-->
                <span class="readBtn" @click="handleRead"><svg-icon icon-class="reading" /></span>
              </div>
            </div>
          </div>
          <bookShowContent :res-id="sourceId" :type="currentType" />
          <div class="tuijian">
            <div class="title">
              <span>推荐家谱</span>
            </div>
            <tuijianBook />
          </div>
          <div style="background-color: #fff;">
            <Speak @showlogin="handleshow" />
          </div>
        </div>
        <div v-show="!isRead" class="rightBox">
          <Rightlist />
        </div>
      </div>
      <div v-show="shareImgShow==true" class="showBox">
        <div class="content">
          <!--<div class="content_msg">-->
          <!--<div v-if="currentType==1" class="imgBox">-->
          <!--<img :src="currentData.SHOW_THUMB_URL" alt="">-->
          <!--</div>-->
          <!--<div v-if="currentType==2" class="imgBox">-->
          <!--<img v-if="currentData.SHOW_THUMB_URL" :src="currentData.SHOW_THUMB_URL" alt="">-->
          <!--<img v-else :src="noIMG_list1" alt="">-->
          <!--</div>-->
          <!--<div v-if="currentType==3" class="imgBox">-->
          <!--<img v-if="currentData.SHOW_THUMB_URL" :src="currentData.SHOW_THUMB_URL" alt="">-->
          <!--<img v-else :src="noIMG_list2" alt="">-->
          <!--</div>-->
          <!--<div v-if="currentType==4" class="imgBox">-->
          <!--<img v-if="currentData.SHOW_THUMB_URL" :src="currentData.SHOW_THUMB_URL" alt="">-->
          <!--<img v-else :src="noIMG_list2" alt="">-->
          <!--</div>-->
          <!--<div class="title">-->
          <!--{{ currentData.SHOW_TITLE }}-->
          <!--</div>-->
          <!--<p>{{ currentData.SHOW_ABSTRACT }}</p>-->
          <!--<div class="content_foot">-->
          <!--<div class="logo_img">-->
          <!--<img :src="logoImage" alt="">-->
          <!--</div>-->
          <!--<div id="qrcode5" ref="qrcode5" />-->
          <!--</div>-->
          <!--</div>-->
          <canvas id="myCanvasNews" width="432" height="630" style="background-color: #fff;" />
          <div id="qrcode5" ref="qrcode5" style="display: none" />
          <div class="closeBtn" @click="handelClose">
            X
          </div>
        </div>
      </div>
      <div v-show="showpuyue==true" class="showpuyue">
        <img :src="srcUrl" alt="">
        <span @click="closepuyue">X</span>
      </div>
    </div>
    <div v-show="isRead" class="goback">
      <span @click="handelBack"><svg-icon icon-class="fanhui" /></span>
    </div>
    <el-dialog
      custom-class="loginBoxs"
      :visible.sync="seelogin"
      width="850px"
      :before-close="handleClose"
    >
      <loginShow />
    </el-dialog>
  </div>
</template>
<script>
import { getBookNews, getTreeNews, getArticleNews, getNodeNews, getEditionHtml, getBookImgsNews, getResIsCollection, addUserCollection, userOutLogin } from '@/api/api.js'
import BookContent from '@/views/components/sourceDetail_content/bookContent/index.vue'
import articleContent from '@/views/components/sourceDetail_content/articleContent/index.vue'
import bookPageContent from '@/views/components/sourceDetail_content/bookPageContent/index.vue'
import nodeContent from '@/views/components/sourceDetail_content/nodeContent/index.vue'
import pictureContent from '@/views/components/sourceDetail_content/pictureContent/index.vue'
import treeContent from '@/views/components/sourceDetail_content/treeContent/index.vue'
import Rightlist from '@/components/commonRightNew/index.vue'
import Speak from '@/components/Detail_speak_source/index.vue'
import { getResIsLife } from '@/api/api.js'
import bookShowContent from '@/views/components/sourceDetail_content/bookShowContent/index.vue'
import tuijianBook from '@/views/components/sourceDetail_content/tuijianBookContent/index.vue'
import loginShow from '@/components/logincomponent/index.vue'
import { ssoUserLogin, addContentSize } from '@/api/api.js'
export default {
  inject: ['reload'],
  components: { loginShow, tuijianBook, bookShowContent, Rightlist, BookContent, articleContent, bookPageContent, nodeContent, pictureContent, treeContent, Speak },
  head() {
    var listObj = this.$store.state.sourceDetailData
    var metaStr = this.contentData.introduceMap.SHOW_ABSTRACT
    // listObj.forEach(a => {
    //   metaStr += a.CONTENT_TITLE + ' | '
    // })
    var keys = '彭祖,彭城,彭氏,彭姓,彭氏家谱,彭氏宗谱,彭氏族谱,彭祖世家,彭氏修谱,门户网站'
    var title = this.contentData.introduceMap.SHOW_TITLE + '-彭祖世家网Pengzushijia.com'
    var desc = '《彭祖世家总谱-事典》门户网站Pengzushijia.COM ，系彭祖世家文化发展有限公司与武汉聚脉网络科技有限公司合作，基于聚脉网络旗下国家发明专利技术产品“大谱师-互联网家谱协作编纂平台”进行品牌定制，专属服务全球彭氏族群编纂《彭祖世家总谱-事典》总谱、家族谱、家庭谱的互联网家谱协作编纂平台。'
    return {
      title: title,
      mateDesc: desc,
      keys: keys
    }
  },
  /**
     * @Description:去掉html标签
     * @author Hp
     * @date 2019/7/15 0015
     */
  filters: {
    changeHTML: function(val) {
      if (val) {
        var newval = val.replace(/<\/?.+?>/g, '')
        return newval.replace(/&ldquo;/g, '').replace(/&rdquo;/g, '')
      } else {
        return ''
      }
    },
    changeShidai: value => {
      if (value) {
        var numToZHCNStr = function(num, yearBol) {
          var chnNumChar = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
          var numStr = parseInt(num).toString().split('')
          if (isNaN(parseInt(num))) {
            numStr = ['0']
          }
          if (yearBol) {
            var Str = ''
            for (var i = 0; i < numStr.length; i++) {
              Str += chnNumChar[parseInt(numStr[i])]
            }
            return Str
          } else {
            if (numStr.toString() == '1,0') {
              return '十'
            }
            if (numStr.length == 1) {
              return chnNumChar[parseInt(numStr[0])]
            } else if (numStr.length == 2) {
              if (parseInt(numStr[0]) == 1) {
                return '十' + chnNumChar[parseInt(numStr[1])]
              } else {
                return chnNumChar[parseInt(numStr[0])] + chnNumChar[parseInt(numStr[1])]
              }
            } else {
              var Str2 = ''
              for (var i = 0; i < numStr.length; i++) {
                Str2 += chnNumChar[parseInt(numStr[i])]
              }
              return Str2
            }
          }
        }
        var changnum = function(str) {
          var newarry = str.split(',')
          if (newarry.length > 1) {
            var newstr = ''
            for (let i = 0; i < newarry.length; i++) {
              var item = newarry[i]
              if (item.split('=').length > 1) {
                var newitem = item.split('=')[0] + '(' + '第' + numToZHCNStr(item.split('=')[1]) + '世' + ')'
                newstr += newitem
                if (i < newarry.length - 1) {
                  newstr += '、'
                }
              } else {
                item += ','
                newstr += item
              }
            }
            return newstr
          } else {
            if (str.indexOf('=') !== -1) {
              return str.split('=')[0] + '(' + '第' + numToZHCNStr(str.split('=')[1]) + '世' + ')'
            } else {
              return str
            }
          }
        }
        return changnum(value)
      } else {
        return ''
      }
    },
    changenull: value => {
      if (value) {
        return value
      } else {
        return '--'
      }
    }
  },
  data() {
    return {
      showpuyue: false,
      fenmian: require('@/static/large1.jpg'),
      loginIMG: require('@/static/bg_txz.png'),
      seelogin: false,
      showcode: false,
      srcUrl: '',
      canSee: false,
      isRead: false,
      logoImage: require('@/static/logo_gengji22.png'),
      puwendefault: require('@/static/puwendefault.jpg'),
      puxidefault: require('@/static/puxidefault.jpg'),
      noIMG_list1: require('@/static/puwenDefaultImg.png'),
      noIMG_list2: require('@/static/puxuDefaultImg.png'),
      sourceId: '',
      names: '',
      shareImgShow: false,
      collectionSize: '',
      isCollected: false,
      list: {},
      listData: {},
      currentData: {},
      currentType: '',
      defaultImg: '',
      peng1: require('@/static/usuerDefault.png'),
      tipImg: require('@/static/wx_erweima.png'),
      noIMG: require('@/static/home_noimg.png'),
      keys: '',
      logo: require('@/static/search_logo_peng.png'),
      currentIndex: 0,
      islogin: false,
      username: '',
      userData: {},
      arrs: [{ 'name': '账号设置' }, { 'name': '我的收藏' }, { 'name': '我的评论' }, { 'name': '我的消息' }, { 'name': '退出登录' }],
      banner_foot: require('@/static/banner_foot.png')
    }
  },
  computed: {
    contentData() {
      return this.$store.state.sourceDetailData
    }
  },
  asyncData({ store, route }) {
    if (route.query.type == 1) {
      return store.dispatch('getBookNews', { bookId: route.query.sourceId })
    }
    if (route.query.type == 2) {
      return store.dispatch('getArticleNews', { articleId: route.query.sourceId })
    }
    if (route.query.type == 3) {
      return store.dispatch('getTreeNews', { treeId: route.query.sourceId })
    }
    if (route.query.type == 4) {
      return store.dispatch('getNodeNews', { nodeId: route.query.sourceId })
    }
  },
  mounted() {
    addContentSize({ resId: this.$route.query.sourceId }).then(res => {

    })
    this.initData()
    localStorage.removeItem('isback')
    this.sourceId = this.$route.query.sourceId
    window.addEventListener('scroll', this.handleScroll, true)
    this.wx2()
    this.wx()
    setTimeout(() => {
      this.canvasInit()
    }, 500)
    this.fn()
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    showpuyuecode() {
      this.showpuyue = true
      this.getImg()
    },
    closepuyue() {
      this.showpuyue = false
    },
    canvasInit() {
      var mycans = document.getElementsByTagName('canvas')[2]// 二维码所在的canvas
      var codeimg = convertCanvasToImage(mycans)

      // /第一个图
      var mycanvas = document.getElementById('myCanvasNews')
      var context = mycanvas.getContext('2d')
      var img1 = new Image()
      // img1.setAttribute('crossOrigin', 'Anonymous')
      if (this.currentData.SHOW_THUMB_URL) {
        img1.src = this.currentData.SHOW_THUMB_URL
      } else {
        if (this.$route.query.type == 2) {
          img1.src = this.noIMG_list1
        }
        if (this.$route.query.type == 3) {
          img1.src = this.noIMG_list2
        }
        if (this.$route.query.type == 4) {
          img1.src = this.noIMG_list2
        }
      }

      var img2 = new Image()
      // img2.setAttribute('crossOrigin', 'Anonymous')
      img2.src = this.logoImage
      var img3 = new Image()
      img3.src = this.loginIMG
      var title = ''
      var avstract = ''
      if (this.currentData.SHOW_TITLE) {
        title = this.currentData.SHOW_TITLE
      }

      if (this.currentData.SHOW_ABSTRACT) {
        avstract = this.currentData.SHOW_ABSTRACT
      }
      function drawText(context, t, x, y, w) {
        var chr = t.split('')
        var temp = ''
        var row = []

        context.font = '20px Arial'
        context.fillStyle = '#a19d9e'
        context.textBaseline = 'middle'

        for (var a = 0; a < chr.length; a++) {
          if (context.measureText(temp).width < w && context.measureText(temp + (chr[a])).width <= w) {
            temp += chr[a] // context.measureText(text).width  测量文本text的宽度
          } else {
            row.push(temp)
            temp = chr[a]
          }
        }
        row.push(temp)

        // for (var b = 0; b < row.length; b++) {
        //   context.fillText(row[b], x, y + (b + 1) * 24)// 字体20，间隔24。类似行高
        // }

        // 只显示2行，加...
        for (var b = 0; b < 3; b++) {
          var str = row[b]
          if (b == 2) {
            str = str.substring(0, str.length - 1) + '...'
          }
          context.fillText(str, x, y + (b + 1) * 24)
        }
      }
      img3.onload = function() {
        context.drawImage(this, 0, 0, 432, 630)
        context.drawImage(codeimg, 280, 460, 100, 100)
        context.drawImage(img2, 30, 490, 173, 56)
        context.drawImage(img1, 0, 0, 436, 270)
        // 第二行文字
        context.textAlign = 'center'
        context.font = '27px Arial'
        context.fillStyle = '#333333'
        var title1 = title.slice(0, 15)
        context.fillText(title1, 216, 300)
        if (title.length > 15) {
          var title2 = title.substring(15)
          context.fillText(title2, 216, 340)
        }
        // /第三行文字
        context.textAlign = 'start'
        context.font = '18px Arial'
        context.fillStyle = '#a19d9e'
        if (avstract) {
          drawText(context, avstract, 10, 350, 410)
        }
      }
      // 画上二维码
      function convertCanvasToImage(canvas) {
        var image = new Image()
        image.src = canvas.toDataURL('image/png')
        return image
      }
    },
    getImg: function() {
      if (!this.srcUrl) {
        if (this.currentType == 4) {
          this.srcUrl = 'http://admin.myfamilybook.cn/jointat-mfb-admin/portalBook/getWeChatQr?resId=' + this.currentData.TREE_ID + '&type=' + 3
        } else {
          this.srcUrl = 'http://admin.myfamilybook.cn/jointat-mfb-admin/portalBook/getWeChatQr?resId=' + this.currentData.SHOW_RES_ID + '&type=' + this.currentType
        }
      }
      this.showcode = !this.showcode
      if (this.showcode) {
        this.$refs.imgCode.style.display = 'inline-block'
      } else {
        this.$refs.imgCode.style.display = 'none'
      }
    },
    handelBack: function() {
      this.reload()
    },
    goclass: function() {
      var pathurl = ''

      if (this.currentType == 1) {
        pathurl = '/bookList'
      }
      if (this.currentType == 2) {
        pathurl = '/booktextList'
      }
      if (this.currentType == 3) {
        pathurl = '/treeList'
      }
      if (this.currentType == 4) {
        pathurl = '/nodeList'
      }
      pathurl = pathurl + '?classz=' + this.currentData.SHOW_CLASSZ_ID
      window.open(pathurl, '_blank')
    },
    handleRead: function() {
      this.isRead = true
      this.$refs.boxShow.style.position = 'absolute'
      this.$refs.boxShow.style.top = '0'
      this.$refs.boxShow.style.width = '100%'
      this.$refs.boxShow.style.backgroundColor = '#fff'
      this.$refs.w1200.style.width = '880px'
      this.$refs.top_right.style.width = '518px'
      this.$refs.showli.style.marginTop = '9px'
      this.$refs.readBox.style.top = '313px'
      this.$refs.w1200.style.border = '1px solid #ccc'
    },
    handelClose: function() {
      this.shareImgShow = false
      this.$refs.share.style.display = 'block'
    },
    handleScroll: function() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (this.$refs.share) {
        if (this.$refs.share.offsetTop + scrollTop - this.$refs.box.offsetHeight - 750 > 0) {
          this.$refs.share.style.position = 'relative'
          this.$refs.share.style.zIndex = '1'
        }
        if (scrollTop + window.innerHeight < this.$refs.box.offsetHeight + 750) {
          this.$refs.share.style.position = 'fixed'
          this.$refs.share.style.bottom = '0'
          this.$refs.share.style.zIndex = '90'
        }
      }
    },
    fn: function() {
      window.scrollTo(0, 0)
    },
    wx: function() {
      this.$refs.qrcode5.innerHTML = ''
      const qrcode5 = new QRCode('qrcode5', {
        text: window.location.href,
        width: 100,
        height: 100,
        colorDark: '#000', // 黑色
        colorLight: '#fff',
        correctLevel: QRCode.CorrectLevel.H
      })
      qrcode5.makeCode(window.location.href)// 生成另一个新的二维码
    },
    gonav: function(index) {
      this.currentIndex = index
    },
    initData() {
      getResIsLife({ resId: this.$route.query.sourceId, resType: this.$route.query.type }).then(res => {
        if (res.data) {
          this.canSee = true
        } else {
          window.close()
        }
      })
      getResIsCollection({ resId: this.$route.query.sourceId }).then(res => {
        this.collectionSize = res.data.collectionSize
        if (res.data.type) {
          this.isCollected = true
        } else {
          this.isCollected = false
        }
      })
      this.currentType = this.$route.query.type
      if (this.currentType == 1) {
        getBookNews({ bookId: this.$route.query.sourceId }).then(res => {
          this.currentData = res.data.newsMap
          this.listData = res.data.introduceMap
          this.names = this.listData.SHOW_TITLE
        })
      }
      if (this.currentType == 2) {
        getArticleNews({ articleId: this.$route.query.sourceId }).then(res => {
          this.currentData = res.data.newsMap
          this.listData = res.data.introduceMap
        })
        this.defaultImg = require('@/static/book_default.png')
        this.names = this.listData.SHOW_TITLE
      }
      if (this.currentType == 3) {
        this.defaultImg = require('@/static/tree_default.png')
        getTreeNews({ treeId: this.$route.query.sourceId }).then(res => {
          this.currentData = res.data.newsMap
          this.listData = res.data.introduceMap
          this.names = this.listData.SHOW_TITLE
          if (this.currentData.FIRST_NODE_NAME) {
            this.currentData.FIRST_NODE_NAME = this.currentData.FIRST_NODE_NAME.split(',')
          } else {
            this.currentData.FIRST_NODE_NAME = []
          }
        })
      }
      if (this.currentType == 4) {
        getNodeNews({ nodeId: this.$route.query.sourceId }).then(res => {
          this.currentData = res.data.newsMap
          this.listData = res.data.introduceMap
          this.names = this.listData.SHOW_TITLE
          var str = /^http/
          if (!str.test(this.currentData.SHOW_THUMB_URL)) {
            this.currentData.DEFAULT_NAME = this.currentData.SHOW_THUMB_URL
            this.currentData.SHOW_THUMB_URL = ''
          }
          if (this.currentData.NODE_LEGAL_NAME) {
            this.currentData.NODE_NAME = this.currentData.NODE_NAME + '，常用名：' + this.currentData.NODE_LEGAL_NAME
          }
          if (this.currentData.NODE_NAME_DESC) {
            this.currentData.NODE_NAME = this.currentData.NODE_NAME + '，别名：' + this.currentData.NODE_NAME_DESC
          }
          var newparentStr = ''
          if (this.currentData.RELATION_MAP.father) {
            newparentStr = this.currentData.RELATION_MAP.father
          }
          if (this.currentData.RELATION_MAP.mather) {
            newparentStr = newparentStr + '-' + this.currentData.RELATION_MAP.mather
          }
          if (this.currentData.RELATION_MAP.childernName) {
            newparentStr = newparentStr + '  ' + this.currentData.RELATION_MAP.childernName
          }
          this.currentData.RELATION_MAP = newparentStr
        })
      }
      if (this.currentType == 5) {
        this.defaultImg = require('@/static/bookPage_default.png')
        getEditionHtml({ htmlId: this.$route.query.sourceId }).then(res => {
          this.currentData = res.data.newsMap
          this.listData = res.data.introduceMap
          this.names = this.listData.SHOW_TITLE
          this.listData.HTML_CONTENT = this.currentData.HTML_CONTENT
        })
      }
      if (this.currentType == 6) {
        getBookImgsNews({ imgId: this.$route.query.sourceId }).then(res => {
          this.currentData = res.data.newsMap
          this.listData = res.data.introduceMap
          this.names = this.listData.SHOW_TITLE
          this.listData.IMGS_URL = this.currentData.IMGS_URL
        })
      }
    },
    weibo: function() {
      var p = {
        count: '1',
        url: window.location.href,
        // 用于发布微博的来源显示， 为空则分享的内容来源会显示来自互联网。(可选， 允许为空)
        appkey: '彭祖世家网',
        // 分享时所示的文字内容， 为空则自动抓取分享页面的title值(可选， 允许为空)
        title: this.currentData.SHOW_TITLE,
        pic: this.currentData.SHOW_THUMB_URL,
        ralateUid: '',
        language: 'zh_cn'
      }
      var s = []
      for (var i in p) {
        s.push(i + '=' + encodeURIComponent(p[i] || ''))
      }
      var url = 'http://service.weibo.com/share/share.php?' + s.join('&')
      window.open(url, '_blank')
    },
    qq: function() {
      var p = {
        /* 获取URL，可加上来自分享到QQ标识，方便统计*/
        url: window.location.href,
        desc: '彭祖世家网',
        /* 分享标题(可选)*/
        title: this.currentData.SHOW_TITLE,
        /* 分享摘要(可选)*/
        summary: this.currentData.SHOW_ABSTRACT,
        /* 分享图片(可选)*/
        pics: this.currentData.SHOW_THUMB_URL,
        /* 视频地址(可选)*/
        flash: '',
        /* 分享来源(可选) 如：QQ分享*/
        site: '彭祖世家网',
        style: '201',
        width: 32,
        height: 32
      }
      var s = []
      for (var i in p) {
        s.push(i + '=' + encodeURIComponent(p[i] || ''))
      }
      var url = 'http://connect.qq.com/widget/shareqq/index.html?' + s.join('&')
      window.open(url, '_blank')
    },
    wx2: function() {
      this.$refs.qrcode3.innerHTML = ''
      const qrcode3 = new QRCode('qrcode3', {
        text: window.location.href,
        width: 100,
        height: 100,
        colorDark: '#000', // 黑色
        colorLight: '#fff',
        correctLevel: QRCode.CorrectLevel.H
      })
      qrcode3.makeCode(window.location.href)// 生成另一个新的二维码
    },
    shareImg: function() {
      this.shareImgShow = true
      this.$refs.share.style.display = 'none'
    },
    goshowcang: function() {

    },
    handelColect: function() {
      ssoUserLogin().then(res => {
        if (res.data.userId) {
          this.setloca('userid', res.data.userId, 7200)
          localStorage.removeItem('unionid')
          if (this.isCollected) {
            addUserCollection({ resId: this.$route.query.sourceId }).then(res => {
              if (res.data) {
                this.isCollected = !this.isCollected
                this.collectionSize--
                this.$message({
                  type: 'success',
                  message: '取消收藏成功'
                })
              }
            })
          } else {
            addUserCollection({ resId: this.$route.query.sourceId }).then(res => {
              if (res.data) {
                this.isCollected = !this.isCollected
                this.collectionSize++
                this.$message({
                  type: 'success',
                  message: '收藏成功'
                })
              }
            })
          }
        } else {
          this.seelogin = true
        }
      })
    },
    goSearch: function() {
      if (this.keys) {
        this.$router.push({ path: '/search', name: 'search', params: { searchName: this.keys }})
      } else {
        this.$message({
          message: '请输入关键字',
          type: 'warning',
          duration: 1500
        })
      }
    },
    goread: function() {
      // if(this.$route.query.type<5){
      ssoUserLogin().then(res => {
        if (res.data.userId) {
          this.setloca('userid', res.data.userId, 7200)
          localStorage.removeItem('unionid')
          var id = this.$route.query.sourceId
          var type = this.$route.query.type
          var url = '/checkRead?id=' + id + '&type=' + type
          window.open(url, '_blank')
        } else {
          this.seelogin = true
        }
      })
    },
    handleClose: function() {
      this.seelogin = false
    },
    handleshow: function() {
      this.seelogin = true
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  .showpuyue{
    position: fixed;
    width: 100%;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 16;
    display: block;
    top: 0;
    left: 0;
    img{
      width: 200px;
      height: 200px;
      position: absolute;
      z-index: 20;
      top: calc( (100vh - 200px)/2 );
      left: calc( (100vw - 200px)/2 );
    }
    span{
      width: 30px;
      height: 30px;
      text-align: center;
      line-height: 30px;
      position: absolute;
      z-index: 20;
      top: 80px;
      right: 35px;
      color: #ffffff;
      border: 2px solid #ffffff;
      border-radius: 50%;
      font-size: 18px;
    }
  }
  .showShare{
    display: none;
  }
  .phoneImgBox{
    position: relative;
    .phoneImg{
      display: none;
    }
  }
  .imgCode{
    width: 100px;
    height: 100px;
    position: absolute;
    display: none;
    top: 116px;
    left: 616px;
    box-shadow: 0 0 0 1px rgba(14,19,24,.07), 0 2px 12px rgba(14,19,24,.2);
    padding: 50px;
    background-color: #fff;
    z-index: 1;
  }
    .title{
      margin: 20px 0;
      padding-bottom: 5px;
      border-bottom: 2px solid #e5e5e5;

      span{
        display: inline-block;
        padding-left: 7px;
        height: 20px;
        border-left: 2px solid #ed4040;
        font-size: 16px;
        line-height: 20px;
      }
    }
    .tuijian{
        overflow: hidden;
        padding: 0 20px;
      background-color: #fff;
      margin-bottom: -20px;
      padding-bottom: 20px;
    }
    .goback{
        position: absolute;
        top: 50px;
        left: 80%;
        svg{
            font-size: 60px;
            color: #a19d9e;
            cursor: pointer;
            &:hover{
                color: #333333;
            }
        }
    }
    .top_msg_read{
        background-color: #fff;
        padding:20px;
        p{
            font-size: 27px;
            color: #333;
            margin-bottom: 10px;
        }
        .top_msg_read_user{
            height: 30px;
            line-height: 30px;
            img{
                width: 30px;
                height: 30px;
                border-radius: 50%;
                vertical-align: top;
                margin-left: 20px;
                margin-right: 10px;
            }
            span{
                color: #b2b2b2;
                font-size: 14px;
                display: inline-block;
                height: 30px;
                vertical-align: top;
            }
        }
    }

    .showli{
        width: 100%;
        margin-top: 46px;
        display: inline-block;
        overflow: hidden;
    }
    #qrcode5{
        display: inline-block;
    }
    .showBox{
        position: fixed;
        width: 100%;
        height: 100vh;
        background-color: rgba(0,0,0,.3);
        z-index: 15;
        display: block;
        top: 0;
        left: 0;
        .content{
            background-color: #fff;
            width: 432px;
            height: 630px;
            margin: 0 auto;
            margin-top: 30px;
            position: relative;
            .content_msg{
                overflow: hidden;
                .imgBox{
                    width: 432px;
                    height: 268px;
                    font-size: 0;
                    overflow: hidden;
                    img{
                        width: 100%;
                        margin-top: -12%;
                    }
                }
                .title{
                    font-size: 27px;
                    color: #333333;
                    font-weight: 500;
                    text-align: center;
                    margin:20px 0;
                    height: 71px;
                    display:-webkit-box;
                    -webkit-line-clamp:2;
                    -webkit-box-orient:vertical;
                    overflow:hidden;
                    word-break: break-all;
                }
                p{
                    display:-webkit-box;
                    -webkit-line-clamp:3;
                    -webkit-box-orient:vertical;
                    overflow:hidden;
                    word-break: break-all;
                    padding: 0 20px;
                    font-size: 18px;
                    color: #a19d9e;
                    line-height: 25px;
                    height: 75px;
                    margin-bottom: 20px;
                    text-align: center;
                }
                .content_foot{
                    border-top: 1px dashed #a19d9e;
                    padding-top: 20px;
                    font-size: 0;
                    height: 130px;
                    background-color: #fff;
                    .logo_img{
                        width: 173px;
                        height: 56px;
                        display: inline-block;
                        vertical-align: top;
                        margin-right: 86px;
                        margin-top: 30px;
                        margin-left: 29px;
                    }
                }
            }
            .closeBtn{
                position: absolute;
                bottom: -22px;
                left: 191px;
                width: 50px;
                height: 50px;
                border-radius: 50%;
                background-color: #ffffff;
                line-height: 50px;
                text-align: center;
                font-size: 20px;
                cursor: pointer;
            }
        }
    }
    .showli_div{
        display: inline-block;
        width: 410px;
        overflow: hidden;
        height: 30px;
        vertical-align: top;
    }
    .showli_div_span1{
        display: inline-block;
        width: 85px;
        height: 30px;
        line-height: 30px;
        font-size: 14px;
        color: #333333;
        font-weight: 600;
        text-align:justify;
        text-justify:distribute-all-lines;
        text-align-last:justify;
    }
    .showli_div_span2{
        display: inline-block;
        width: 310px;
        height: 30px;
        line-height: 30px;
        vertical-align: top;
        color: #666666;
        font-size: 14px;
        white-space: nowrap;
        text-overflow:ellipsis;
        overflow: hidden;
    }
    .showli_div_node{
        max-height: 60px;
        height: auto;
        white-space: normal;
        .nodeli{
            display: inline-block;
            width: 80px;
            height: 20px;
            overflow: hidden;
            background-color: #E8E8E8;
            text-align: center;
            line-height: 20px;
            border-radius: 3px;
            margin-top: 5px;
            margin-right: 5px;
        }
    }
    .showli_div_span1_line{
        width: 600px;
    }
    .showli_div_span2_class{
        display: inline-block;
        height: 20px;
        line-height: 20px;
        border: 1px solid #7E6B5A;
        border-radius: 5px;
        text-align: center;
        width: 80px;
        color: #7E6B5A;
        font-size: 14px;
    }
    .leftImg{
        width:319px;
        display: inline-block;
        margin-top: 20px;
        position: relative;
        overflow: hidden;
        border-right: 1px solid #f1f1f1;
    }
    .tipname{
        display: inline-block;
        width: 57px;
        height: 0;
        border-width: 0 35px 35px 35px;
        border-style: none solid solid;
        border-color: transparent transparent #7E6B5A;
        transform: rotate(-45deg);
        position: absolute;
        top: 15px;
        left: 15px;
    }
    .tipname_text{
        position: absolute;
        width: 80px;
        text-align: center;
        transform: rotate(-45deg);
        top: 23px;
        color: #ffffff;
        left:38px;
    }
    .top_msg_show_user{
        display: inline-block;
        float: right;
        max-width: 200px;
        overflow: hidden;
        height: 60px;
        line-height: 60px;
        margin-right: 35px;
        img{
            vertical-align: middle;
            margin-top: -7px;
            width: 36px;
            height: 36px;
            border-radius: 50%;
            margin-right: 5px;
        }
        span{
            color: #545454;
            font-size: 16px;
        }
    }
    .top_msg_show{
        width: 1165px;
        height: 60px;
        line-height: 60px;
        background-color: #fff;
        border-bottom: 2px solid #EAEAEA;
        padding-left: 35px;
        .top_msg_show_name{
            font-size: 18px;
            font-weight: 600;
            color: #333333;
        }
        .class_name{
            font-size: 14px;
            color: #908E8E;
            margin-left: 15px;
        }
    }
  .tips{
    height: 30px;
    line-height: 30px;
    background-color: #fff;
    margin:20px 0;
    border: 1px solid #F1F1F1;
    padding-left: 35px;
    .btnSty{
      margin: 0 5px;
      color: #7E6B5A;
    }
  }
  ////分享样式
    .readBox{
        overflow: hidden;
        position: absolute;
        display: inline-block;
        top: 279px;
        left: 360px;
    }
  .btn_read{
   width: 120px;
   height: 36px;
    background-color: #7E6B5A;
    color: #ffffff;
    line-height:36px;
    text-align: center;
    font-size: 16px;
    display: inline-block;
    cursor: pointer;
      margin-right: 10px;
      span{
          margin-right: 3px;
          font-weight: 600;
      }
  }
  .btn_read_code{
      background-color: #ffffff;
      color: #7E6B5A;
      border: 1px solid #7E6B5A;
  }
  .moreShare{
    display: inline-block!important;
    vertical-align: top;
    height: 50px;
    line-height: 50px;
    a{
      background-image: none;
      margin-top: 18px;
      color: #7E6B5A;
      font-size:18px;
    }
  }
  .moreShare2{
    display: inline-block!important;
    vertical-align: top;
    height: 30px;
    line-height: 30px;
    text-align: center;
    a{
      background-image: none;
      font-size:22px;
      color: #7E6B5A;
      margin-right: 10px
    }
  }
  .wxImg{
    position: relative;
    &:hover > #qrcode3{
      display: inline-block;
      top: -105px;
      left:-50px;
    }
  }
  #qrcode3{
    top: -105px;
    background-color: #fff;
    display: none;
    position: absolute;
    z-index: 5;
  }
  .share{
    height: 52px;
    border-bottom:  1px solid #e5e5e5;
    border-top:  1px solid #e5e5e5;
    line-height:52px;
    width: 880px;
    position: fixed;
    bottom: 0;
    background-color: #fff;
    z-index: 9999;
    .btn{
      margin-left: 5px;
      &:hover{
        color: #ed4040;
        cursor: pointer;
      }
    }
    .star{
      display: inline-block;
      float: right;
    }
    span{
      display: inline-block;
      color: #7E6B5A;
      margin-left: 20px;
      vertical-align: top;
      svg{
        font-size: 18px;
        cursor: pointer;
        &:hover{
          color: #ed4040;
        }
      }
      i{
        font-size: 18px;
        cursor: pointer;
        &:hover{
          color: #ed4040;
        }
      }
    }
    .rightbox{
      float: right;
      display: inline-block;
      height: 52px;
      padding: 0 10px;
      span{
        vertical-align: middle;
      }
      .num{
        margin-left: 5px;
      }
      .collected {
        display: inline-block;
        svg {
          color: #ed4040;
        }
      }
      .nocollected{
        display: inline-block;
        svg{
          color: #ccc;
        }
      }
      .readBtn{
        padding-left: 10px;
        border-left: 1px solid #a19d9e;
        height: 20px;
        line-height: 20px;
        display: inline-block;
      }
    }
  }
    ///列表样式
    .topShow{
      height: 375px;
      width: 1198px;
      border: 1px solid #F1F1F1;
      background-color: #fff;
        position: relative;
      .top_left{
        width: 320px;
        height: 100%;
        display: inline-block;
        overflow: hidden;
        vertical-align: top;
        .coverImg{
          margin-left: 45px;
          width: 233px;
          height: 330px;
          display: inline-block;
          border-left: 1px solid #f0f0f0;
          border-right: 3px solid #f0f0f0;
          border-bottom: 3px solid #f0f0f0;
          -moz-box-shadow:1px 1px 3px #f3f3f3;
          -webkit-box-shadow:1px 1px 3px #f3f3f3;
          box-shadow:1px 1px 3px #f3f3f3;
          img{
            width: 233px;
            height: 330px;
            vertical-align: top;
          }
        }
      }
      .top_right{
        padding-left: 40px;
        display: inline-block;
        width: 836px;
        vert-align: top;
        height: 100%;
        .to_right_content{
          margin-top: 25px;
          display: inline-block;
          width: 760px;
          background-color: #F2F2F2;
          padding: 10px 15px;
          padding-bottom: 20px;
          span{
            color: #666666;
            height: 66px;
            font-size: 12px;
            display: inline-block;
            overflow:hidden;
            line-height: 22px;
            text-overflow:ellipsis;
            display:-webkit-box;
            -webkit-box-orient:vertical;
            -webkit-line-clamp:3;
          }
        }
      }
    }
    .leftBox{
        width: 880px;
        margin-right: 20px;
        margin-top: 20px;
        float: left;
    }
    .rightBox{
        width: 300px;
        margin-top: 20px;
        float: right;
        overflow: hidden;
      vertical-align: top;
      margin-bottom: 20px;
    }
    .newsBox {
        position: relative;
        width: 100%;
        background-color: #F9F9F9;
        .top {
            position: absolute;
            top: 0;
            width: 100%;
            height: 140px;
            top: -180px;
            background-color: #fff;
          z-index: 8;
            .navs {
                height: 40px;
                background-color: #7e6b5a;
                width: 100%;
                .w1200s {
                    width: 1200px;
                    height: 40px;
                    background-color: #7e6b5a;
                    margin: 0 auto;
                    position: relative;
                    .head-ul {
                        display: inline-block;
                        overflow: hidden;
                        height: 40px;
                        background-color: #7e6b5a;
                        li {
                            display: inline-block;
                            margin-top: 10px;
                            a {
                                padding: 5px 14px;
                                margin: 0 5px;
                                cursor: pointer;
                                color: #ffffff;
                            }
                        }
                    }
                    .right_box {
                        display: inline-block;
                        float: right;
                        .login_register {
                            border-radius: 5px;
                            float: right;
                            width: 88px;
                            height: 28px;
                            margin: 5px 20px;
                            line-height: 28px;
                            /*border: 1px solid #ed4040;*/
                            a {
                                display: inline-block;
                                width: 42px;
                                text-align: center;
                                height: 16px;
                                margin-top: 6px;
                                font-size: 12px;
                                line-height: 16px;
                                color: #ffffff;
                            }
                        }
                        .login_register a:nth-of-type(1) {
                            border-right: 1px solid #fff;
                        }
                        .userBox {
                            border-radius: 5px;
                            width: 90px;
                            height: 30px;
                            margin: 5px 20px;
                            line-height: 30px;
                            transition: 0.5s;
                            position: absolute;
                            z-index: 7;
                            right: 0;
                            top: 0;
                            overflow: hidden;
                            &:hover {
                                height: 240px;
                            }
                            .imgBox {
                                width: 30px;
                                height: 30px;
                                border-radius: 50%;
                                display: inline-block;
                                background-color: #e6e6e6;
                                vertical-align: top;
                                cursor: pointer;
                                font-size: 0;
                                img {
                                    width: 30px;
                                    height: 30px;
                                    border-radius: 50%;
                                }
                            }
                            .usercontent {
                                width: 150px;
                                display: inline-block;
                                height: 30px;
                                font-size: 12px;
                                color: #ffffff;
                                /*overflow: hidden;*/
                                margin-left: 5px;
                                cursor: pointer;
                                position: absolute;
                                z-index: 6;
                            }
                            .list {
                                margin-top: 10px;
                                background-color: #fff;
                                li {
                                    text-align: center;
                                    height: 36px;
                                    line-height: 36px;
                                    font-size: 12px;
                                    cursor: pointer;
                                    &:hover {
                                        background-color: #ed4040;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            .logoBox {
                width: 444px;
                height: 60px;
                font-size: 0;
                display: inline-block;
                cursor: pointer;
                margin-top: 40px;
                vertical-align: top;
                img {
                    width: 444px;
                    height: 60px;
                }
            }
            .searchbox {
                display: inline-block;
                overflow: hidden;
                float: right;
                margin-top: 45px;
                span {
                    display: inline-block;
                    height: 38px;
                    width: 98px;
                    border: 1px solid #7e6b5a;
                    vertical-align: top;
                    text-align: center;
                    line-height: 40px;
                }
                .keys_input {
                    height: 38px;
                    width: 313px;
                    border-top: 1px solid #7e6b5a;
                    border-bottom: 1px solid #7e6b5a;
                    border-left: 1px solid #7e6b5a;
                    padding-left: 5px;
                    vertical-align: top;
                }
                .btn {
                    display: inline-block;
                    background-color: #7e6b5a;
                    color: #ffffff;
                    line-height: 40px;
                    height: 40px;
                    text-align: center;
                    width: 101px;
                    cursor: pointer;
                }
            }
            .bannerbox {
                width: 100%;
                height: 500px;
                font-size: 0;
                margin-top: 40px;
                position: relative;
                background-position: center center;
                background-size: auto 100%;
                img {
                    width: 100%;
                    height: 500px;
                }
                .numberCount {
                    position: absolute;
                    top: 332px;
                    width: 100%;
                    text-align: center;
                    color: #bb955b;
                    font-family: '微软宋体';
                }
            }
        }
    }
  .collect_span_img{
    display: none;
  }
</style>
<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
  @media screen and (max-width: 750px) {
    .phoneNO{
      display: none;
    }
    .newsBox{
      padding: 0 20px;
      background-color: #fff;
      .w1200{
        background-color: #fff!important;
      }
    }
    .top_msg_show{
      width: 100%;
      height: auto;
      line-height: 25px;
      padding-left: 0;
      .top_msg_show_name{
        display: none;
      }
      .top_msg_show_name_title{
        display: block;
        margin-bottom: 10px;
        z-index: 2;
        position: relative;
        color: #ffffff;
        top: 10px;
        left: 5px;
      }
      .class_name_1{
        margin-left: 0;
      }
    }
    .showli_div_span1_line{
      width: 250px;
    }
    .top{
      display: none;
    }
    .tipImg{
      height:190px!important;
      img{
        display: none;
      }
      p{
        display: none!important;
      }
    }
    .leftBox{
      .share{
        display: none;
      }
    }
    .topShow{
      width: 100%;
      height: auto;
      border: none;
    }
    .top_left{
      display: none!important;
    }
    .top_right{
      width: 100%!important;
      padding: 0 0!important;
      display: block;
      .collect_span_1{
        width: 100%!important;
        text-align: center;
      }
    }
    .left_phone{
      display: none!important;
    }
    .collect_span{
      display: none!important;
    }
    .showli{
      width: 100%;
      margin-top: 5px;
    }
    .leftBox{
      width: 100%!important;
    }
    .to_right_content{
      width: 100%!important;
      padding: 10px 0px !important;
      margin:0 0!important;
      margin-top: 20px!important;
      span{
        padding: 0 10px;
      }
    }
    .rightBox{
      display: none;
    }
    .btn_read{
      display: none!important;
    }
    .tips{
      display: none;
    }
    .collect_span_img{
      margin-top: 10px;
      display: block;
      width: 100%;
      height: auto;
      text-align: center;
      img{
        width: 75%;
        height: auto;
      }
    }
    .showli_div_span2{
      width: 250px;
    }
    .showli_div_node{
      margin-bottom: 7px;
    }
    .top_msg_show_user{
      display: none;
    }
    .tuijian{
      padding: 0;
      padding-bottom: 20px;
    }
    .readBox{
      display: none;
    }
    .phoneImgBox{
      position: relative;
      top: 10px;
      margin-bottom: 20px;
      .phoneImg{
        filter: blur(1px);
        position: absolute;
        display: inline-block;
        top: 0;
        left: 0;
        width: 100%;
        height: 100px;
        z-index: 1;
        /*height: ;*/
      }
    }
    .top_msg_show .class_name{
      position: relative;
      z-index: 2;
      color: #fff;
      top: 10px;
      left: 5px;
    }
    .showShare{
      display: block;
      text-align: center;
      overflow: hidden;
      padding-top: 20px;
      border-top: 1px dashed #999;
      margin-top: 10px;
      span{
        display: inline-block;
        padding: 8px 70px;
        background-color: #7E6B5A;
        color: #ffffff;
      }
    }
  }
</style>
